import APIS from "../../constant/EndPoint";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import usePostHook from "../../customHooks/usePostHook";
import MultipleSelectField from "../Reusable/MultipleSelect";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const AssignGroup = (props: any) => {
  const { user, roles } = props;
 
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    watch,
    setValue,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...user?.profile,
      };
    },
  });

  const { mutateAsync, isPostLoading: isPostLoading } = usePostHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {

    const url = `${APIS.USER}assign-group/`;
    let formData = {
      roles: values?.roles?.map((item: any, index: number) => item.value),
      user: user?.id,
    }; 
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) =>
          handleUpdateProfile(data, setError)
        )}
        autoComplete="off"
      >
        <div className={tw`grid  md:grid-cols-2 gap-x-4 mx-4`}>
          <MultipleSelectField
            label={"Select Roles"}
            queryKey={"roles"}
            register={register("roles")}
            watch={watch}
            setValue={setValue}
            url={APIS.GROUP}
            value={
              user?.groups?.length
                ? user?.groups?.map((item: any, index: number) => ({
                    label: item?.name,
                    value: item?.pk,
                  }))
                : []
            }
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button label={"Update"} isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default AssignGroup;
